module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVEhLtZVBDsIwDARz4KE98jT+xGMgRtmQuozUJelIrmytOo5yaEtlq3WLZjHhDHd51Xq2YcUiicMZ7s9DNbMoi1U7+RjM1OjqjU6g+d/SDWj+No08nwU9GJigBwMT9Kh51LoPs4veC0e4ukdNLpdfjqjeHDab6L3DTfSmkeezoAcDE/RgYIIeDEzQg4EJejAwQQ8GJujBwAQ9ai7/XF/+w1GgE7joBvJBp8WZvGiZOFOdZXsDaFXr7TL/LCgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-open-window/dark/24.png
// module id = 2284
// module chunks = 2